import React, { useMemo, useState } from "react";
import { CalendarDays, ChevronRight, Sparkles } from "lucide-react";
import { blogPosts } from "../mock";

function formatDate(d) {
  const date = new Date(d);
  return new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(date);
}

export default function Blog() {
  const [active, setActive] = useState(blogPosts[0]?.slug);

  const post = useMemo(
    () => blogPosts.find((p) => p.slug === active) ?? blogPosts[0],
    [active]
  );

  return (
    <div className="page" style={{ paddingTop: 96 }}>
      <div
        style={{
          padding: "0 clamp(2.2rem, 6vw, 8rem)",
          maxWidth: 1200,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gap: 18,
        }}
      >
        <div style={{ gridColumn: "span 5" }}>
          <div className="contact-label-luxe" style={{ marginBottom: 12 }}>
            <Sparkles size={14} />
            <span>BLOG</span>
          </div>
          <h1
            className="contact-title-luxe"
            style={{ margin: 0, fontSize: "clamp(2.2rem, 4.2vw, 3.2rem)" }}
          >
            Notes, models,
            <br />
            <span className="contact-title-gradient">and reflections</span>
          </h1>

          <div style={{ marginTop: 22, display: "grid", gap: 12 }}>
            {blogPosts.map((p) => {
              const isActive = p.slug === active;
              return (
                <button
                  key={p.slug}
                  type="button"
                  onClick={() => setActive(p.slug)}
                  className={`pillars-scrollpin__content`}
                  style={{
                    textAlign: "left",
                    cursor: "pointer",
                    padding: 18,
                    borderColor: isActive
                      ? "rgba(255,182,217,0.35)"
                      : "rgba(255,182,217,0.14)",
                    background: isActive
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(255,255,255,0.03)",
                    transition: "background-color .25s ease, border-color .25s ease",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "inline-flex",
                          gap: 8,
                          alignItems: "center",
                          fontSize: 12,
                          color: "rgba(255,255,255,0.62)",
                        }}
                      >
                        <CalendarDays size={14} />
                        <span>{formatDate(p.date)}</span>
                        <span style={{ opacity: 0.7 }}>•</span>
                        <span>{p.readTime}</span>
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          fontFamily: "Playfair Display, Georgia, serif",
                          fontSize: 18,
                          color: "rgba(255,255,255,0.90)",
                        }}
                      >
                        {p.title}
                      </div>
                      <div style={{ marginTop: 8, color: "rgba(255,255,255,0.75)", lineHeight: 1.7 }}>
                        {p.excerpt}
                      </div>
                    </div>
                    <ChevronRight
                      size={18}
                      style={{
                        opacity: isActive ? 0.9 : 0.5,
                        transform: isActive ? "translateX(2px)" : "translateX(0)",
                        transition: "transform .2s ease, opacity .2s ease",
                      }}
                    />
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        <div style={{ gridColumn: "span 7" }}>
          <article className="about-immersive__quote" style={{ textAlign: "left" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontFamily: "Playfair Display, Georgia, serif",
                  fontSize: 28,
                  lineHeight: 1.2,
                }}
              >
                {post.title}
              </h2>
              <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
                {formatDate(post.date)} • {post.readTime}
              </div>
            </div>

            <div style={{ marginTop: 18, color: "rgba(255,255,255,0.82)", lineHeight: 1.9 }}>
              {post.body.map((para) => (
                <p key={para} style={{ marginTop: 12 }}>
                  {para}
                </p>
              ))}
            </div>

            <div style={{ marginTop: 22, color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
              Posts are MOCKED for now. Later we can add a CMS or backend CRUD.
            </div>
          </article>
        </div>
      </div>

      <div style={{ height: 80 }} />

      <style>{`
        @media (max-width: 980px){
          .page > div[style*="grid-template-columns"]{
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}
